import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCommunityData,
  updateCommunityApi,
  deleteCommunityData,
} from "../CommunityAPI/communityApi";

const communitySlice = createSlice({
  name: "community",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    setCommunity: (state, action) => {
      state.community = action.payload; // Store entire community object
    },

setStatus: (state, action) => {
  state.loading = false;
  

  // Ensure state.data is always an array, even if it's null or not an array
  if (!Array.isArray(state.data)) {
   
    state.data = [];  // Reset to empty array if it's not an array
  }

  // Now state.data is always an array, you can safely use map
  state.data = state.data.map((community) => {
 

    // Update the community status if the id matches
    return community.id === action.payload.id
      ? { ...community, status: action.payload.statuss }
      : community; // Keep other communities unchanged
  });


},

    
    
    
  },
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(fetchCommunityData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommunityData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCommunityData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateCommunityApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCommunityApi.fulfilled, (state, action) => {
    

        state.loading = false;
    
        // Update the status of the specific community object by matching its id
        // state.data = state.data.map(
        //   (community) =>
        //     community.id === action.payload.data.id
        //       ? { ...community, status: action.payload.data.status } // Update the status
        //       : community // Keep other communities unchanged
        // );
      })
      .addCase(updateCommunityApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // .addCase(deleteCommunityData.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(deleteCommunityData.fulfilled, (state, action) => {
      //   console.log("updateCommunityApi new", action.payload.data);

      //   state.loading = false;
      //   // Update the status of the specific community object by matching its id
      //   state.data = state?.data?.filter(
      //     (community) => community.id !== action.payload.data.id
      //   );
      // })
      // .addCase(deleteCommunityData.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.error.message;
      // });
  },
});

export const { setCommunity, setStatus } = communitySlice.actions;
export default communitySlice.reducer;
